import { createRouter, createWebHistory } from 'vue-router';
import { isLoggedIn } from '@/utils/storage';

// 路由懒加载
const HomePage = () => import('@/pages/HomePage.vue');
const LoginPage = () => import('@/pages/LoginPage.vue');
const CourseListPage = () => import('@/pages/CourseListPage.vue');
const CourseDetailPage = () => import('@/pages/CourseDetailPage.vue');
const RedeemPage = () => import('@/pages/RedeemPage.vue');
const DashboardPage = () => import('@/pages/DashboardPage.vue');
const VideoPlayerPage = () => import('@/pages/VideoPlayerPage.vue');
const FAQPage = () => import('@/pages/FAQPage.vue');
const ParentGuidePage = () => import('@/pages/ParentGuidePage.vue');
const AboutPage = () => import('@/pages/AboutPage.vue');
const AssessmentPage = () => import('@/pages/AssessmentPage.vue');

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: { title: '首页' }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: { title: '登录' }
  },
  {
    path: '/courses',
    name: 'CourseList',
    component: CourseListPage,
    meta: { title: '课程列表' }
  },
  {
    path: '/courses/:id',
    name: 'CourseDetail',
    component: CourseDetailPage,
    meta: { title: '课程详情' }
  },
  {
    path: '/redeem',
    name: 'Redeem',
    component: RedeemPage,
    meta: { title: 'CDK兑换', requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardPage,
    meta: { title: '学习中心', requiresAuth: true }
  },
  {
    path: '/player/:courseId/:lessonId',
    name: 'VideoPlayer',
    component: VideoPlayerPage,
    meta: { title: '视频播放', requiresAuth: true }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQPage,
    meta: { title: '常见问题' }
  },
  {
    path: '/for-parents',
    name: 'ParentGuide',
    component: ParentGuidePage,
    meta: { title: '家长指南' }
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
    meta: { title: '关于我们' }
  },
  {
    path: '/assessment',
    name: 'Assessment',
    component: AssessmentPage,
    meta: { title: '心理测评' }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = `${to.meta.title || ''} - 路过客·K12心理提分课`;

  // 检查是否需要登录
  if (to.meta.requiresAuth && !isLoggedIn()) {
    next({
      name: 'Login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

export default router;
